export { default } from './StarOutline'
